import { GetNotificationType, SendReferralType } from "./types";

export const notificationsSlr = (state: any): GetNotificationType => state.notification.notifications;

export const referralSlr = (state: any): SendReferralType => state.notification.referral;
